import { request } from 'sonata-react-components';
import { DealInterface } from 'sonata-static-storage/lib/schemas/premium/deal.schema';

export async function getDeal(dealId: string, token?: Record<string, any>): Promise<DealInterface<string> | null> {
  const result = await request.makeRequest(
    `${taptap.config.backendUrlBase}deal`,
    {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET',
      params: {
        filterActive: true,
        filterString: dealId,
        filterUserManagement: true,
        limit: 1,
        page: 1
      }
    },
    token
  );
  return result.items[0] ?? null;
}

export async function assignDealToUsers(dealId: string, userIds: string[], token?: Record<string, any>): Promise<void> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}users/assignDeals`,
    {
      data: {
        dealIds: [dealId],
        userIds
      },
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    },
    token
  );
}

export async function unassignDeal(dealId: string, userIds: string[], token?: Record<string, any>): Promise<void> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}users/assignDeals`,
    {
      data: {
        dealIds: [dealId],
        userIds
      },
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'DELETE'
    },
    token
  );
}

export async function getDealAssignedUsers(
  dealId: string,
  token?: Record<string, any>
): Promise<{ id: string; name: string }[]> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}users/assignDeal/${dealId}`,
    {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET'
    },
    token
  );
}
